import { Discount } from 'shared-types';

type DiscountDisplayObject = {
  discountedPrice?: { amount: number; currencyCode: string } | null;
  standardPrice?: { amount: number; currencyCode: string } | null;
};

export const mapDiscountToDisplayObject = (
  discount: Discount | undefined | null
): DiscountDisplayObject | undefined => {
  if (!discount) return undefined;

  return {
    discountedPrice: discount.discountedPrice
      ? {
          amount: discount.discountedPrice.amount,
          currencyCode: discount.discountedPrice.currencyCode,
        }
      : undefined,
    standardPrice: discount.standardPrice
      ? {
          amount: discount.standardPrice.amount,
          currencyCode: discount.standardPrice.currencyCode,
        }
      : undefined,
  };
};
